import React from "react";
import "./Legal.scss";

const PrivacyPolicy = () => (
    <main className="legal-page">
        <h1>Privacy Policy</h1>
        <p><strong>Last updated:</strong> October 30, 2025</p>

        <h2>1. Introduction</h2>
        <p>
            Welcome to <strong>TechADive</strong> (“we”, “our”, or “us”). We value your privacy and are committed to protecting your personal data in accordance with the General Data Protection Regulation (GDPR).
        </p>

        <h2>2. Data We Collect</h2>
        <p>
            We may collect the following types of information when you interact with our website:
        </p>
        <ul>
            <li>Personal details (name, email) submitted via contact forms</li>
            <li>Usage data (e.g., pages visited, time spent, browser type)</li>
            <li>Cookies and analytics data (for performance and improvement)</li>
        </ul>

        <h2>3. How We Use Your Data</h2>
        <ul>
            <li>To respond to inquiries and provide support</li>
            <li>To improve our website’s functionality and user experience</li>
            <li>To comply with legal obligations</li>
        </ul>

        <h2>4. Legal Basis for Processing</h2>
        <p>
            We process your personal data under the following legal bases:
        </p>
        <ul>
            <li>Consent (e.g., when you submit a contact form)</li>
            <li>Legitimate interest (e.g., to analyze and improve site performance)</li>
            <li>Legal obligations (e.g., record-keeping or compliance requirements)</li>
        </ul>

        <h2>5. Data Retention</h2>
        <p>
            We retain personal data only as long as necessary to fulfill the purposes outlined in this policy or as required by law.
        </p>

        <h2>6. Your Data Protection Rights (GDPR)</h2>
        <p>You have the right to:</p>
        <ul>
            <li>Access, correct, or delete your personal data</li>
            <li>Withdraw consent at any time</li>
            <li>Request a copy of the data we hold about you</li>
            <li>Lodge a complaint with your local data protection authority</li>
        </ul>

        <h2>7. Data Security</h2>
        <p>
            We use appropriate technical and organizational measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction.
        </p>

        <h2>8. Contact Us</h2>
        <p>
            If you have any questions about this Privacy Policy or wish to exercise your data rights, please contact:
        </p>
        <address>
            <strong>TechADive</strong><br />
            Lang’ata, Nairobi / Warsaw, Poland<br />
            Email: <a href="mailto:info@techadive.com">info@techadive.com</a>
        </address>
    </main>
);

export default PrivacyPolicy;
